import React from 'react'
import { Domain } from 'Types/Domain'
import { GtmLeftSetion, Row, VerticalSeparator, GtmScrollInstruction } from './Instructions.styled'
import { GoogleTagManagerAuto } from './elements/GoogleTagManagerAuto/GoogleTagManagerAuto'
import { GoogleTagManagerManualMethod } from './elements/GoogleTagManagerManual/GoogleTagManagerManualMethod'

type GoogleTagManagerWrapperProps = {
  tagUrl: string
  domain: Domain | undefined
}

export const GoogleTagManager = ({ tagUrl, domain }: GoogleTagManagerWrapperProps) => {
  return (
    <Row id={'boarding-gtm-tab'}>
      <GtmLeftSetion>
        <GoogleTagManagerAuto domain={domain} />
      </GtmLeftSetion>
      <VerticalSeparator />
      <GtmScrollInstruction>
        <GoogleTagManagerManualMethod
          noMargin
          tagUrl={tagUrl}
          domainHashCode={domain?.tagHashCode || ''}
        />
      </GtmScrollInstruction>
    </Row>
  )
}
